export const FORM_STATE_TYPES = {
  SET_FORM_IS_DIRTY: 'SET_FORM_IS_DIRTY',
};
